import request from '@/utils/request'

// 加载 
export function loadnews(params) {
    return request({
      url: '/api/CmsArticle/LoadQT',
      method: 'get',
      params
    })
  }


  export function addNews(data) {
    return request({
      url: '/api/CmsArticle/Add',
      method: 'post',
      data
    })
  }
// 删除
  export function DeleteNews(data) {
    return request({
      url: '/api/CmsArticle/Delete',
      method: 'post',
      data
    })
  }
// 获取单个数据
  export function GetNews(params) {
    return request({
      url: '/api/CmsArticle/Get',
      method: 'get',
      params
    })
  }
// 编辑
  export function updateNews(data) {
    return request({
      url: '/api/CmsArticle/Update/Update',
      method: 'post',
      data
    })
  }
// 上传图片
  export function uploadDoc(data) {
    return request({
      url: '/resource/File/UploadPic',
      method: 'post',
      data
    })
  }
  export function addUserFeedback(data) {
    return request({
        url: '/api/UserFeedback/Add',
        method: 'post',
        data
    })
}
export function getLoadDowload(params) {
  return request({
    url: '/api/CmsDown/Load',
    method: 'get',
    params
  })
}
export function getDownCount(params) {
  return request({
    url: '/api/CmsDown/DownCount',
    method: 'get',
    params
  })
}

